<template>
  <div v-if="normalized.length" class="fp">
    <div v-for="(f, i) in normalized" :key="i" class="fp-item">
      <!-- Image: thumbnail preview (click opens full image) -->
      <a
        v-if="f.isImage"
        :href="f.fileUrl"
        target="_blank"
        rel="noopener"
        class="fp-thumb"
        :title="f.fileName"
      >
        <img :src="f.fileUrl" :alt="f.fileName" />
      </a>
      <!-- Non-image: download box (click downloads) -->
      <div v-else class="fp-box" :title="f.fileName" @click="download(f)">
        <v-icon size="22" color="#117443">mdi-download</v-icon>
        <span class="fp-ext">{{ f.ext || 'FILE' }}</span>
      </div>
      <div class="fp-name" :title="f.fileName">{{ f.fileName }}</div>
    </div>
  </div>
  <span v-else class="fp-empty">—</span>
</template>

<script>
const IMAGE_EXT = ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp"];

export default {
  name: "FilePreview",
  props: {
    files: { type: Array, default: () => [] },
  },
  computed: {
    normalized() {
      return (this.files || [])
        .map((f) => {
          const fileUrl = f.fileUrl || f.attachmentLink || f.link || f.s3Location || "";
          const fileName = f.fileName || f.name || this.nameFromUrl(fileUrl) || "file";
          const ext = this.extOf(fileName || fileUrl);
          return { fileUrl, fileName, ext: (ext || "").toUpperCase(), isImage: IMAGE_EXT.includes((ext || "").toLowerCase()) };
        })
        .filter((f) => f.fileUrl);
    },
  },
  methods: {
    extOf(s) {
      const clean = String(s || "").split("?")[0].split("#")[0];
      const m = clean.match(/\.([a-zA-Z0-9]+)$/);
      return m ? m[1] : "";
    },
    nameFromUrl(url) {
      const clean = String(url || "").split("?")[0].split("#")[0];
      return clean.substring(clean.lastIndexOf("/") + 1);
    },
    async download(f) {
      try {
        const res = await fetch(f.fileUrl);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = f.fileName || "file";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        // Cross-origin / CORS fallback: open in a new tab so the user can save.
        window.open(f.fileUrl, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.fp {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 4px;
}
.fp-item {
  width: 120px;
}
.fp-thumb,
.fp-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}
.fp-thumb {
  border: 1px solid #e3e3e3;
  background: #f8f8f8;
}
.fp-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.fp-box {
  flex-direction: column;
  gap: 2px;
  background: #eef7f1;
  border: 1px solid #d6eee1;
}
.fp-ext {
  font-size: 14px;
  font-weight: 700;
  color: #117443;
  letter-spacing: 0.5px;
}
.fp-name {
  margin-top: 6px;
  font-size: 12px;
  color: #1e1e1e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fp-empty {
  color: #979797;
}
</style>
